export const setDefAcYearCompany = (defAcYearCompany) => {
    return {
        type: "SET_DefAcYearCompany",
        defAcYearCompany,
    };
};
export const setPrevAcYearCompany = (prevAcYearCompany) => {
    return {
        type: "SET_PrevAcYearCompany",
        prevAcYearCompany,
    };
};